import React from 'react'

import styles from './Menu.css'

const Menu = ({ context, children }) => {
  return (
    <ol className={styles.menu}>
      {React.Children.map(children, child =>
        React.cloneElement(child, { className: styles.menu_item, context })
      )}
    </ol>
  )
}

export default Menu
